import { Component } from 'preact';
import api from '@/api';
import { useFormProps, useAdvanced } from '@/features/form';
import ReCaptcha from './ReCaptcha';

export default function RecaptchaWrapper(props) {
	const { formKey, domain, customDomain } = useFormProps();
	const advanced = useAdvanced();

	return (
		<RecaptchaHandler
			{...props}
			domain={domain}
			customDomain={customDomain}
			formKey={formKey}
			siteKey={advanced?.recaptcha?.siteKey}
		/>
	);
}

class RecaptchaHandler extends Component {
	reCaptchaNode = null;

	validateCaptcha = e => {
		const { domain, customDomain } = this.props;
		api({ domain, customDomain })
			.validateReCaptcha({
				surveyKey: this.props.formKey,
				recaptcha: e
			})
			.then(r => {
				if (r.recaptchaValid) {
					this.props.setValue(true);
				} else {
					try {
						this.reCaptchaNode.reset();
					} catch (e) {}
				}
			})
			.catch(e => {
				try {
					this.reCaptchaNode.reset();
				} catch (e) {}
			});
	};

	expireCaptcha = e => {
		try {
			this.props.setValue('');
		} catch (e) {}
	};

	render() {
		return (
			<ReCaptcha
				key="recaptcha"
				ref={this.reCaptchaNode}
				sitekey={this.props.siteKey}
				onChange={e => this.validateCaptcha(e)}
				onExpired={e => this.expireCaptcha(e)}
			/>
		);
	}
}
